import { render, staticRenderFns } from "./w-examples.vue?vue&type=template&id=55497aeb"
import script from "./w-examples.vue?vue&type=script&lang=js"
export * from "./w-examples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports